import React from 'react';
import ADIconLogo from 'assets/images/icons/adnoc-logo.png';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import { useDispatch } from 'react-redux';
import { VENDOR_LOGIN } from 'actions/authAction';

const loginSchema = Yup.object({
  password: Yup.string().required('Password is Required').trim('Space is not allowed').strict(true),
  email: Yup.string()
    .required('Email is Required')
    .strict(true)
    .trim('Space is not allowed')
    .email('Please enter valid email id')
    .max(100, 'Text limit should be less than 100 characters.'),
});

const LoginAsVendor = () => {
  return (
    <main className="login-page__main">
      <div className="login-bg-block">
        <div className="login-content-block">
          <div className="logo-block">
            <div className="logo--img">
              <img src={ADIconLogo} alt="Adnoc" />
            </div>
          </div>
          <div className="page-block__main">
            <div className="title">Login</div>
            <p className="sub-title">Welcome to Adnoc</p>
            <div className="login-tab">
              <div className="tab-block">
                <div className="tab-content-block">
                  <div className="tab-content__item active" id="login-tab">
                    {<LoginPage />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

const LoginPage = () => {
  const dispatch = useDispatch();

  return (
    <div className="login-form__block">
      <Formik
        initialValues={{ email: '', password: '' }}
        validationSchema={loginSchema}
        onSubmit={(values, { setSubmitting }) => {
          dispatch({ type: VENDOR_LOGIN, payload: values });
          setSubmitting(false);
        }}
      >
        {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
          <Form onSubmit={handleSubmit}>
            <div className="form-block--wrapper">
              <div className="form--content">
                <TextInput
                  isRequired
                  label="Email"
                  placeholder="Email"
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  error={errors.email && touched.email ? errors.email : null}
                />
                <TextInput
                  label="Password"
                  name="password"
                  type="password"
                  value={values.password}
                  onChange={handleChange}
                  error={errors.password && touched.password ? errors.password : null}
                />
              </div>
              <div className="login-button--block">
                <Button type="submit" className="login--btn" disabled={isSubmitting}>
                  Login
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default LoginAsVendor;
